import isApiError from "@insite/client-framework/Common/isApiError";
import { ApiParameter, ServiceResult, get } from "@insite/client-framework/Services/ApiService";
import { BaseModel } from "@insite/client-framework/Types/ApiModels";

export interface GetCreateQuoteHistoryApiParameter extends ApiParameter {
    customerSequence?: string;
    sort?: string;
    dateType?: string;
    toDate?: string;
    fromDate?: string;
    status?: string;
    selectedpage?: string;
    ordersearchtype?: string;
    isSearch?: string;
    dateRange?: string;
    dateRangeDesc?: string;
    statusDesc?: string;
    quotetype?: string;
    quotetypeDesc?: string;
    properties?: string;
    currentPage?: string;
    pageSize?: string;
    poNumber?: string;
    isSearchActive?: boolean;
}

export interface CreateQuoteHistoryModel extends BaseModel {
    fileName: string;
}

const createFileURL = "/api/v2/exportorder";

export async function getExportQuoteHistory(
    parameter: GetCreateQuoteHistoryApiParameter,
): Promise<ServiceResult<CreateQuoteHistoryModel>> {
    try {
        const getCreateQuoteHistory = await get<CreateQuoteHistoryModel>(`${createFileURL}`, {
            customerSequence: parameter.customerSequence,
            sort: parameter.sort,
            dateType: parameter.dateType,
            toDate: parameter.toDate,
            fromDate: parameter.fromDate,
            status: parameter.status,
            selectedpage: parameter.selectedpage,
            ordersearchtype: parameter.ordersearchtype,
            isSearch: parameter.isSearch,
            dateRange: parameter.dateRange,
            dateRangeDesc: parameter.dateRangeDesc,
            statusDesc: parameter.statusDesc,
            quotetype: parameter.quotetype,
            quotetypeDesc: parameter.quotetypeDesc,
            properties: parameter.properties,
            currentPage: parameter.currentPage,
            pageSize: parameter.pageSize,
            poNumber: parameter.poNumber,
            isSearchActive: parameter.isSearchActive,
        } as any);
        return {
            result: getCreateQuoteHistory,
            successful: true,
        };
    } catch (error) {
        if (isApiError(error) && error.status === 400) {
            return {
                successful: false,
                errorMessage: error.errorJson.message,
            };
        }
        throw error;
    }
}

